module.exports = __webpack_public_path__ + "static/media/247.24328136.webp";